import { graphql, HttpResponse } from 'msw'
import {
  type UpdateInvestmentFixedIncomeCategoriesOutput,
  type InvestmentFixedIncomeCategoriesRecommendationOutput,
} from '../../../models'

export const investmentFixedIncomeCategoriesRecommendation: InvestmentFixedIncomeCategoriesRecommendationOutput = {
  governmentBonds: {
    recommendedPercent: 30,
    allowedMinPercent: 20,
    allowedMaxPercent: 30,
    allowedMaxAllocationPercent: 32,
  },
  highYieldBonds: {
    recommendedPercent: 30,
    allowedMinPercent: 10,
    allowedMaxPercent: 30,
    allowedMaxAllocationPercent: 32,
  },
  municipalBonds: {
    recommendedPercent: 15,
    allowedMinPercent: 25,
    allowedMaxPercent: 30,
    allowedMaxAllocationPercent: 32,
  },
  corporateBonds: {
    recommendedPercent: 15,
    allowedMinPercent: 10,
    allowedMaxPercent: 30,
    allowedMaxAllocationPercent: 32,
  },
  internationalBonds: {
    recommendedPercent: 10,
    allowedMinPercent: 0,
    allowedMaxPercent: 20,
    allowedMaxAllocationPercent: 32,
  },
  currentBreakdown: {
    __typename: 'InvestmentFixedIncomeCategoryBreakdown',
    governmentBonds: 20,
    highYieldBonds: 30,
    municipalBonds: 10,
    corporateBonds: 10,
    internationalBonds: 30,
  },
}

export const updateInvestmentFixedIncomeCategories: UpdateInvestmentFixedIncomeCategoriesOutput = {
  __typename: 'InvestmentFixedIncomeCategoryBreakdown',
  governmentBonds: 20,
  highYieldBonds: 30,
  municipalBonds: 10,
  corporateBonds: 10,
  internationalBonds: 30,
}

export const mockInvestmentFixedIncomeRecommendation = graphql.query(
  'investmentFixedIncomeCategoriesRecommendation',
  () => {
    return HttpResponse.json({ data: { investmentFixedIncomeCategoriesRecommendation } })
  },
)

export const mockFixedIncomeUpdateMutation = graphql.mutation('updateInvestmentFixedIncomeCategories', () =>
  HttpResponse.json({ data: { updateInvestmentFixedIncomeCategories } }),
)

export const mockFixedIncomeCategories = [mockInvestmentFixedIncomeRecommendation, mockFixedIncomeUpdateMutation]
